//Module Keys
let locales = {};

//Merge Views

//Main
import mainView from '../../views/main/lan/en';
locales = { ...locales, ...mainView };

import performanceDashboardView from '../../views/dashboard/lan/en';
locales = { ...locales, ...performanceDashboardView };

import performanceDriverView from '../../views/driver/lan/en';
locales = { ...locales, ...performanceDriverView };

import performanceEventsView from '../../views/events/lan/en';
locales = { ...locales, ...performanceEventsView };

import performanceEventsAdvancedFilters from '../../views/events/modals/advancedFilters/lan/en';
locales = { ...locales, ...performanceEventsAdvancedFilters };

import performanceEventsDriverInfo from '../../views/events/modals/driverInfo/lan/en';
locales = { ...locales, ...performanceEventsDriverInfo };

import performanceEventsEditEvent from '../../views/events/modals/editEvent/lan/en';
locales = { ...locales, ...performanceEventsEditEvent };

import performanceEventsAssetInfo from '../../views/events/modals/assetInfo/lan/en';
locales = { ...locales, ...performanceEventsAssetInfo };

import performanceEventsEventInfo from '../../views/events/modals/eventInfo/lan/en';
locales = { ...locales, ...performanceEventsEventInfo };

import performanceDriverModals from '../../views/driver/modals/advancedFilters/lan/en';
locales = { ...locales, ...performanceDriverModals };

import overviewTab from '../../views/overviewTab/lan/en';
locales = { ...locales, ...overviewTab };

import caseDetailView from '../../views/caseDetail/lan/en';
locales = { ...locales, ...caseDetailView };

import caseView from '../../views/cases/lan/en';
locales = { ...locales, ...caseView };

import performanceCasesEditCoachPanel from '../../views/cases/modals/editCoachPanel/lan/en';
locales = { ...locales, ...performanceCasesEditCoachPanel };

import performanceDriverDetail from '../../views/driverDetail/lan/en';
locales = { ...locales, ...performanceDriverDetail };

import performanceCasesAdvancedFilters from '../../views/cases/modals/advancedFilters/lan/en';
locales = { ...locales, ...performanceCasesAdvancedFilters };

import performanceCasesCreatePanel from '../../views/cases/modals/createPanel/lan/en';
locales = { ...locales, ...performanceCasesCreatePanel };

import performanceImplovementPlanTab from '../../views/implovementPlanTab/lan/en';
locales = { ...locales, ...performanceImplovementPlanTab };

import performanceOverviewTabDriver from '../../views/overviewTabDriver/lan/en';
locales = { ...locales, ...performanceOverviewTabDriver };

import performanceEventsCaseInfo from '../../views/events/modals/caseInfo/lan/en';
locales = { ...locales, ...performanceEventsCaseInfo };

import performanceEventsRiskTab from '../../views/riskTab/lan/en';
locales = { ...locales, ...performanceEventsRiskTab };

import performanceDriverModalsCreateDriverCoaching from '../../views/driver/modals/createDriverCoaching/lan/en';
locales = { ...locales, ...performanceDriverModalsCreateDriverCoaching };

import performanceCasesViewCreatePanel from '../../views/cases/modals/viewCreationPanel/lan/en';
locales = { ...locales, ...performanceCasesViewCreatePanel };

import performanceEventsAssignDriver from '../../views/events/modals/assingDriver/lan/en';
locales = { ...locales, ...performanceEventsAssignDriver };

import performanceEventsAssignStatus from '../../views/events/modals/assingStatus/lan/en';
locales = { ...locales, ...performanceEventsAssignStatus };

import performanceHistoryTooltip from '../../views/implovementPlanTab/modals/historyTooltip/lan/en';
locales = { ...locales, ...performanceHistoryTooltip };

import performanceFunctionTab from '../../views/functionTab/lan/en';
locales = { ...locales, ...performanceFunctionTab };

import coachingEducationWidget from '../../views/functionTab/widgets/coachingEducation/lan/en';
locales = { ...locales, ...coachingEducationWidget };

import performanceImprovementWidget from '../../views/functionTab/widgets/performanceImprovement/lan/en';
locales = { ...locales, ...performanceImprovementWidget };

import interventionWidget from '../../views/functionTab/widgets/intervention/lan/en';
locales = { ...locales, ...interventionWidget };

import escalationWidget from '../../views/functionTab/widgets/escalation/lan/en';
locales = { ...locales, ...escalationWidget };

import configurationDetail from '../../views/configurationDetail/lan/en';
locales = { ...locales, ...configurationDetail };

import performanceRiskEventsTab from '../../views/riskEventsTab/lan/en';
locales = { ...locales, ...performanceRiskEventsTab };

import dateRangeModal from '../../views/overviewTab/modals/dateRangeModal/lan/en';
locales = { ...locales, ...dateRangeModal };

export default locales;
